import { Map } from 'immutable'

export const initialState = Map({
  highlightSlice: null,
  zoomOnHighlightSliceChange: null,
  hoverSlice: null,
  highlightPoint: null,
  hoverCue: null
})

export const types = {
  HIGHLIGHT_POINT: 'highlightPoint'
}

export function reducer (state, action) {
  switch (action.type) {
    case types.HIGHLIGHT_POINT:
      return state.set('highlightPoint', action.point)
    default:
      console.error('Action type not supported')
      return state
  }
}
